module.exports = __webpack_public_path__ + "static/media/nevada.cc410fea.pdf";